import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


export default function Login() {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // const response = await fetch("http://localhost/myapp/api/login.php", {
      const response = await fetch("https://astro.cubixsystems.com/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // credentials: "include",
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.status === "success") {
        localStorage.setItem("auth", "loggedin");
        // ✅ redirect to dashboard
        navigate("/Dashboard");

      } else {
        setMessage(result.message);
      }
    } catch (error) {
      setMessage("Server error");
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-5" >
          <div className="left">
            <div className="form">
              <img src="images/astro.png" alt="" style={{ width: '50%' }} />
              <h2 style={{ fontFamily: 'anek malayalam', fontWeight: '300' }}>Login</h2>
              <form onSubmit={handleSubmit} className="form-details">
                <input
                  type="text"
                  name="username"
                  placeholder="Username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  className=""
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className=""
                />
                <button
                  type="submit"
                  className="btn btn-primary btn-login"
                >
                  Login
                </button>
              </form>
              {message && <p className="mt-4 text-center text-sm">{message}</p>}
            </div>
          </div>
        </div>
        <div className="col-md-7" style={{ backgroundImage: 'url(./images/bg.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="right">
            <div style={{ height: '100vh', display: 'flex', alignItems: 'end', justifyContent: 'center', color: 'white', paddingBottom: '50px' }}>
              <h1 style={{ color: 'white', borderTop: '1px solid white', padding: '15px', fontSize: '10px' }}>Powered by Cubix Software Solutions</h1>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
